module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/hero-mobile-ed1649a16e46f6dd6dd2ea83099e2d22.webp";